import {
  CircularProgress,
} from '@material-ui/core/';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import {
  inject, observer,
} from 'mobx-react';
import React from 'react';
import {
  CountryStore,
} from '../../../mobx-store/stores/countryStore';
import SearchFilterDropdown from '../../SearchFilterComponent/SearchFilterDropdown';

interface IProps {
  open: boolean;
  filter?: boolean;
  loading?: boolean;
  isEgypt?: boolean;
  countryStore?: CountryStore;
  handleClose(): void;
  handleSend(
    titleEn: string,
    bodyEn: string,
    titleAr: string,
    bodyAr: string,
    status: string,
    type: string,
    navigationItemType: string,
  ): Promise<void>;
}
interface IState {
  textValueTitleEn: string;
  textValueBodyEn: string;
  textValueTitleAr: string;
  textValueBodyAr: string;
  status: string;
}

@inject('countryStore')
@observer
class FeaturedArticleNotificationModal extends React.Component<IProps, IState> {
  searchFilterDropdown: any;

  typeFilterDropDown: any;

  constructor(props: IProps) {
    super(props);
    this.state = ({
      textValueTitleEn: '',
      textValueBodyEn: '',
      textValueTitleAr: '',
      textValueBodyAr: '',
      status: this.props.isEgypt ? 'all' : 'nonmembers',
    });
  }

  selectSearchChange(newFilter: any) {
    this.setState({
      status: newFilter,
    });
  }

  getArticleSearchFilterDropDown = () => {
    let filters = [
      {
        value: 'all', name: 'all',
      },
      {
        value: 'members', name: 'members',
      },
      {
        value: 'nonmembers', name: 'nonmembers',
      }
    ];
    if (!this.props.isEgypt) {
      filters = [
        {
          value: 'nonmembers', name: 'nonmembers',
        }
      ]
    }
    const sendTo = {
      value: this.state.status,
      onChange: this.selectSearchChange.bind(this),
      filters,
    }
    return sendTo;
  };

  handleTitleEnStateChange = (event: any) => {
    this.setState({
      textValueTitleEn: event.target.value,
    });
  };

  handleBodyEnStateChange = (event: any) => {
    this.setState({
      textValueBodyEn: event.target.value,
    });
  };
  
  handleTitleArStateChange = (event: any) => {
    this.setState({
      textValueTitleAr: event.target.value,
    });
  };

  handleBodyArStateChange = (event: any) => {
    this.setState({
      textValueBodyAr: event.target.value,
    });
  };

  resetState = () => {
    this.setState({
      textValueTitleEn: '',
      textValueBodyEn: '',
      textValueTitleAr: '',
      textValueBodyAr: '',
      status: this.props.isEgypt ? 'all' : 'nonmembers',
    });
  };

  handleSubmit = async () => {
    const {
      textValueTitleEn,
      textValueBodyEn,
      textValueTitleAr,
      textValueBodyAr,
      status,
    } = this.state;
    try {
      await this.props.handleSend(
        textValueTitleEn,
        textValueBodyEn,
        textValueTitleAr,
        textValueBodyAr,
        status,
        'internal',
        'article',
      );
      this.resetState();
    } catch (error) {
      console.log(error);
    }
  };

  handleCancel = () => {
    this.props.handleClose();
    this.resetState();
  };

  render() {
    this.searchFilterDropdown = this.getArticleSearchFilterDropDown();

    return (
      <div >
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Subscribe</DialogTitle>
          <DialogContent >
            <DialogContentText>
                    Choose the title and body of the notification.
            </DialogContentText>

            <SearchFilterDropdown searchFilterDropdown={this.searchFilterDropdown} />

            <TextField
              onChange={this.handleTitleEnStateChange}
              autoFocus
              margin="dense"
              id="titleEn"
              label="Title English"
              fullWidth
            />

            <TextField
              onChange={this.handleBodyEnStateChange}
              autoFocus
              margin="dense"
              id="bodyEn"
              label="Body English"
              fullWidth
            />
            <TextField
              onChange={this.handleTitleArStateChange}
              autoFocus
              margin="dense"
              id="titleAr"
              label="Title Arabic"
              fullWidth
            />

            <TextField
              onChange={this.handleBodyArStateChange}
              autoFocus
              margin="dense"
              id="bodyAr"
              label="Body Arabic"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCancel()} color="primary">
                    Cancel
            </Button>
            <Button
              onClick={() => this.handleSubmit()}
              color="primary"
            >
              { this.props.loading ? <CircularProgress /> : 'Send'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default FeaturedArticleNotificationModal;
